/**
 * InvitationExpired Component
 *
 * Story 5.7: Invitation Acceptance Flow (Task 6)
 * Displayed when invitation token has expired.
 */

import type { JSX } from 'react';
import { Link } from 'react-router-dom';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { Button, Card, CardBody } from '@heroui/react';

export function InvitationExpired(): JSX.Element {
  return (
    <div className="flex min-h-[60vh] items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardBody className="items-center gap-4 py-8 text-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-warning-100">
            <ExclamationTriangleIcon className="h-8 w-8 text-warning-700" />
          </div>

          <h1 className="text-2xl font-semibold">Invitation Expired</h1>

          <p className="text-default-500">
            This invitation link has expired and is no longer valid.
          </p>

          <p className="text-sm text-default-400">
            Please contact the organization administrator to receive a new invitation.
          </p>

          <Button as={Link} to="/" color="primary" className="mt-4">
            Go to Home
          </Button>
        </CardBody>
      </Card>
    </div>
  );
}
